import React, { Component } from "react";
import RenderFormField from "./RenderFormField";
import { Row, Col } from "react-bootstrap";
import "./form-field.style.scss";
import { yesNoOptions } from "./constants";
import RenderFormFieldView from "./RenderFormFieldView";
import * as Http from "../../../../http";

export default class FacilityInfo extends Component {
  state = {
    collateralTypeOptions: [],
    productOptions: [],
  };
  componentDidMount() {
    Http.getPricingCollateralMaster().then((res) => {
      const data = res.Data || {};
      const types = Object.values(data).map((collateral) => ({
        value: collateral.collateral_type,
        label: collateral.collateral_type_name,
      }));
      this.setState({ collateralTypeOptions: types });
    });

    Http.getPricingProductMaster().then((res) => {
      const data = res.Data || {};
      const filterType = this.props.type === "retail" ? "Retail" : "Corporate";
      const types = Object.values(data)
        .filter((prd) => prd.cust_segment_code === filterType)
        .map((prd) => ({
          value: prd.product_type,
          label: prd.product_type_name,
        }));

      this.setState({ productOptions: types });
    });
  }
  render() {
    const { collateralTypeOptions, productOptions } = this.state;
    const { prefillData, isView } = this.props;
    const isFromPopup = !!(prefillData && prefillData.customer_id);

    // Fields pre-filled from popup — skip from editable form, show as summary
    const POPUP_FIELD_NAMES = new Set([
      "tentative_loan_product_code",
      "tentative_loan_product",
      "tentative_loan_amount",
      "tentative_loan_ccy",
      "collateral_type",
      "collateral_type_name",
      "collateral_value",
      "collateral_currency",
    ]);

    const formatNum = (v) => {
      if (!v) return "-";
      return Number(v).toLocaleString("en-US");
    };

    const collateralName = (() => {
      if (!prefillData) return "";
      const opt = collateralTypeOptions.find(
        (o) => o.value === prefillData.collateral_type,
      );
      return opt ? opt.label : prefillData.collateral_type || "-";
    })();

    const RenderCom = isView ? RenderFormFieldView : RenderFormField;
    return (
      <div>
        <Row>
          <Col xs={12}>
            <p className="FormTitle">Facility Information</p>
          </Col>
        </Row>

        {isFromPopup && (
          <Row>
            <Col xs={12}>
              <div
                style={{
                  background: "#f8f9fa",
                  border: "1px solid #dee2e6",
                  borderRadius: 6,
                  padding: "12px 16px",
                  marginBottom: 16,
                  fontSize: 13,
                }}
              >
                <div
                  style={{ fontWeight: 600, marginBottom: 8, color: "#333" }}
                >
                  Pre-filled information
                </div>
                <div
                  style={{ display: "flex", flexWrap: "wrap", gap: "8px 24px" }}
                >
                  <div>
                    <span style={{ color: "#666" }}>Product: </span>
                    <strong>{prefillData.tentative_loan_product || "-"}</strong>
                  </div>
                  <div>
                    <span style={{ color: "#666" }}>Loan Amount: </span>
                    <strong>
                      {formatNum(prefillData.tentative_loan_amount)}{" "}
                      {prefillData.tentative_loan_ccy || "VND"}
                    </strong>
                  </div>
                  <div>
                    <span style={{ color: "#666" }}>Collateral Type: </span>
                    <strong>{collateralName}</strong>
                  </div>
                  <div>
                    <span style={{ color: "#666" }}>Collateral Value: </span>
                    <strong>
                      {formatNum(prefillData.collateral_value)}{" "}
                      {prefillData.collateral_currency || "VND"}
                    </strong>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        )}

        <Row>
          {facilityInformationFields(collateralTypeOptions, productOptions)
            .filter(
              (field) =>
                !(
                  isFromPopup &&
                  field.name &&
                  POPUP_FIELD_NAMES.has(field.name)
                ),
            )
            .map((field) => (
              <Col
                key={field.name || field.type}
                xs={12}
                md={field.fullWidth ? 12 : 6}
              >
                <RenderCom {...field} formValues={this.props.formValues} />
              </Col>
            ))}
        </Row>
      </div>
    );
  }
}

const facilityInformationFields = (collateralTypeOptions, productOptions) => [
  {
    name: "tentative_loan_product_code",
    type: "dropdown",
    label: "Tentative loan product code",
    options: productOptions.map((col) => ({
      label: col.value,
      value: col.value,
    })),
  },
  {
    name: "tentative_loan_product",
    label: "Tentative loan product",
    type: "readonlyDropdown",
    dependOn: "tentative_loan_product_code",
    options: productOptions,
  },
  {
    name: "contract_id",
    type: "input",
    label: "Contract ID",
  },
  {
    name: "tentative_loan_amount",
    type: "input-number",
    label: "Tentative loan amount",
    isFormatNumber: true,
  },
  {
    name: "tentative_loan_ccy",
    type: "dropdown",
    label: "Tentative loan currency",
    options: [{ label: "VND", value: "VND" }],
  },
  {
    name: "tentative_loan_tenor",
    type: "input",
    label: "Tentative loan tenor",
  },
  {
    name: "original_date",
    type: "datePicker",
    label: "Original Date",
  },
  {
    name: "interest_rate_type",
    type: "dropdown",
    label: "Interest Rate Type",
    options: [
      { label: "Fixed", value: "Fixed" },
      { label: "Float", value: "Float" },
    ],
  },
  {
    type: "space",
    fullWidth: true,
    height: "2rem",
  },
  {
    name: "payment_frequency",
    type: "dropdown",
    label: "Payment Frequency",
    options: [
      { label: "Monthly", value: "Monthly" },
      { label: "Quarterly", value: "Quarterly" },
      { label: "Yearly", value: "Yearly" },
    ],
  },
  {
    name: "repricing_frequency",
    type: "dropdown",
    label: "Repricing Frequency",
    options: [
      { label: "3", value: "3" },
      { label: "6", value: "6" },
      { label: "9", value: "9" },
      { label: "12", value: "12" },
    ],
  },
  {
    name: "payment_amount_1",
    type: "input-number",
    label: "Payment Amount 1",
    isFormatNumber: true,
  },
  {
    name: "start_date_payment_1",
    type: "datePicker",
    label: "Start Date Payment 1",
  },
  {
    name: "total_no_of_payment_1",
    type: "input",
    label: "Total no of Payment 1",
  },
  {
    type: "space",
    fullWidth: true,
    height: "1px",
  },
  {
    name: "payment_amount_2",
    type: "input-number",
    label: "Payment Amount 2",
    isFormatNumber: true,
  },
  {
    name: "start_date_payment_2",
    type: "datePicker",
    label: "Start Date Payment 2",
  },
  {
    name: "total_no_of_payment_2",
    type: "input",
    label: "Total no of Payment 2",
  },
  {
    type: "button",
    height: "2rem",
    label: "+ ADD PAYMENT",
  },
  {
    type: "space",
    fullWidth: true,
    height: "2rem",
  },
  {
    name: "collateral_type",
    type: "dropdown",
    label: "Collateral Type",
    options: collateralTypeOptions.map((col) => ({
      label: col.value,
      value: col.value,
    })),
  },
  {
    name: "collateral_type_name",
    type: "readonlyDropdown",
    dependOn: "collateral_type",
    label: "Collateral Type Name",
    options: collateralTypeOptions,
  },
  {
    name: "collateral_id",
    type: "input",
    label: "Collateral ID",
  },
  {
    name: "collateral_currency",
    type: "dropdown",
    label: "Collateral Currency",
    options: [{ label: "VND", value: "VND" }],
  },
  {
    name: "collateral_value",
    type: "input-number",
    label: "Collateral Value",
    isFormatNumber: true,
  },
  {
    name: "collateral_value_in_local_currency",
    type: "input-number",
    label: "Collateral Value in local currency",
    isFormatNumber: true,
  },
  {
    type: "space",
    fullWidth: true,
    height: "1px",
  },
  {
    name: "collateral_senior_claim_flag",
    type: "dropdown",
    label: "Collateral Senior Claim?",
    options: yesNoOptions,
  },
  // {
  //   name: "collateral_eligible_cre_rre_flag",
  //   type: "dropdown",
  //   label: "Collateral Eligible Cre Rre?",
  //   options: yesNoOptions,
  // },
  // {
  //   name: "eligible_other_irb_collat_flag",
  //   type: "dropdown",
  //   label: "Eligible Other Lrb Collateral?",
  //   options: yesNoOptions,
  // },
  // {
  //   name: "eligible_irb_receivables_flag",
  //   type: "dropdown",
  //   label: "Eligible Lrb Receivables?",
  //   options: yesNoOptions,
  // },
  // {
  //   name: "eligible_guarantee_flag",
  //   type: "dropdown",
  //   label: "Eligible guarantee?",
  //   options: yesNoOptions,
  // },
];



// WEBPACK FOOTER //
// src/pages/Pricing/NewPricing/components/FacilityInfo.js